/** Format INR for dashboard tiles/axes (lakh/crore) or exact tooltip figures. */
export function formatInr(amount, { compact = true, digits } = {}) {
  if (amount == null || Number.isNaN(Number(amount))) return '—';
  const n = Number(amount);
  const abs = Math.abs(n);

  if (!compact) {
    return `₹${n.toLocaleString('en-IN', {
      maximumFractionDigits: digits ?? 0,
      minimumFractionDigits: 0,
    })}`;
  }

  if (abs >= 1e7) {
    const cr = n / 1e7;
    return `₹${cr.toLocaleString('en-IN', {
      maximumFractionDigits: digits ?? (Math.abs(cr) >= 10 ? 1 : 2),
    })} Cr`;
  }

  if (abs >= 1e5) {
    const lakh = n / 1e5;
    return `₹${lakh.toLocaleString('en-IN', {
      maximumFractionDigits: digits ?? 1,
    })} L`;
  }

  return `₹${n.toLocaleString('en-IN', {
    maximumFractionDigits: digits ?? 0,
  })}`;
}

export function formatCount(n) {
  if (n == null || Number.isNaN(Number(n))) return '—';
  return Number(n).toLocaleString('en-IN');
}

export function formatPct(n, digits = 1) {
  if (n == null || Number.isNaN(Number(n))) return '—';
  return `${Number(n).toLocaleString('en-IN', { maximumFractionDigits: digits })}%`;
}
